module.exports = __webpack_public_path__ + "img/minzheng.7815a1de.png";